import { getApiData } from "../utils/APIHelper";

const ENDPOINTS = {
  LIST_BY_PROJECT: (projectId) => `api/concepts/project/${projectId}`,
  ONE: (id) => `api/concepts/${id}`,
};

const safeCall = async (fn, label) => {
  try {
    return await fn();
  } catch (error) {
    console.error(`${label} error:`, error);
    throw error;
  }
};

// ---------- Status mapping (UI ↔ API) ----------

export const apiStatusToUi = (s) => {
  switch ((s || "").toUpperCase()) {
    case "SENT":
      return "sent_to_user";
    case "APPROVED":
      return "approved";
    default:
      return "draft";
  }
};

// ---------- Palette helpers ----------

export const palettesFromApi = (raw) => {
  if (!raw) return [];
  try {
    const arr =
      typeof raw === "string" ? JSON.parse(raw) : Array.isArray(raw) ? raw : [];
    return arr
      .map((item) => ({ order: Number(item?.order) || 0, hex: item?.hex || "" }))
      .filter((c) => c.hex)
      .sort((a, b) => a.order - b.order)
      .map((c) => c.hex);
  } catch {
    return [];
  }
};

// ---------- Read-only fetches ----------

export const getConceptsByProject = (projectId) =>
  safeCall(
    () => getApiData(ENDPOINTS.LIST_BY_PROJECT(projectId), "GET", {}),
    "Get concepts"
  );

export const getConcept = (conceptId) =>
  safeCall(
    () => getApiData(ENDPOINTS.ONE(conceptId), "GET", {}),
    "Get concept"
  );
